/** Reads a monotonic millisecond source (performance.now in browsers). Never Date.now: a system
 * clock change must not misalign the voice and the event log (EC23). */
export type NowFn = () => number

/** Milliseconds since recording start, excluding paused time. */
export class PauseAwareClock {
  private startedAt: number | null = null
  private pausedAt: number | null = null
  private pausedTotal = 0
  private stoppedOffset: number | null = null

  constructor(private readonly now: NowFn) {}

  start(): void {
    if (this.startedAt !== null) return
    this.startedAt = this.now()
  }

  pause(): void {
    if (this.startedAt === null || this.pausedAt !== null || this.stoppedOffset !== null) return
    this.pausedAt = this.now()
  }

  resume(): void {
    if (this.pausedAt === null) return
    this.pausedTotal += this.now() - this.pausedAt
    this.pausedAt = null
  }

  stop(): void {
    if (this.startedAt === null || this.stoppedOffset !== null) return
    this.stoppedOffset = this.offsetMs()
  }

  offsetMs(): number {
    if (this.startedAt === null) return 0
    if (this.stoppedOffset !== null) return this.stoppedOffset
    const reference = this.pausedAt ?? this.now()
    return reference - this.startedAt - this.pausedTotal
  }

  get isPaused(): boolean {
    return this.pausedAt !== null
  }
}
